import React from 'react';
import { Card } from '../ui/Card';
import { Message, Task } from '../../types';
import { PieChart } from './charts/PieChart';
import { calculateDepartmentEngagement } from '../../utils/analytics';
import { motion } from 'framer-motion';

interface DepartmentEngagementProps {
  messages: Message[];
  tasks: Task[];
}

export const DepartmentEngagement: React.FC<DepartmentEngagementProps> = ({ messages, tasks }) => {
  const departmentData = calculateDepartmentEngagement(messages, tasks);

  return (
    <Card className="p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <PieChart
          title="Department Engagement"
          data={departmentData.map(dept => ({
            label: dept.department,
            value: dept.engagement,
            color: dept.color
          }))}
        />

        <div className="mt-6 space-y-4">
          {departmentData.map((dept) => (
            <div key={dept.department} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className={`w-3 h-3 rounded-full ${dept.color}`} />
                <span className="text-sm font-medium">{dept.department}</span>
              </div>
              <div className="text-sm text-gray-600">
                <span className="font-medium">{dept.taskCount}</span> tasks,{' '}
                <span className="font-medium">{dept.messageCount}</span> messages
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </Card>
  );
};